<template>
    <div class="mb-5">
        <div class="col-md-12">
            <boton-atras :nombre_ruta="'Menu'"/>
        </div>
        <div class="container text-center mb-5">
          <h1 class="bold300 text-uppercase" style=" font-weight:500;">Cuenta de la Hacienda Pública Estatal</h1>
        </div>
        <div v-if="textoPrincipal">
            <p>{{ textoPrincipal }}</p>
        </div>
        <div class="col-12 my-3" v-if="listadoAnios">
            <px-select idSelect="tomo_CP" placeholder="Seleccione año a consultar" :options="listadoAnios" @KuramaSelect="anioSeleccionado = $event"></px-select>
        </div>
        <div v-if="anioSeleccionado" class="mt-4">
            <h3>{{ anioSeleccionado.text }}</h3>
            <div class="row">
                <div class="col-md-9"><p class="text-justify" v-html="txtdescripcionCuentaPublica"></p></div>
                <div class="col-md-3 contenedor_img_cp "><img :src="urlServe + anioSeleccionado.img" class="img-fluid" width="210" height="263"/></div>
            </div>
            <!--  -->
            <!-- listadoDocumentosCtaPubPorAnio -->
            <div v-if="listadoDocumentosCtaPubPorAnio" class="col-md-12">
                <card-collapse-docs-nodos :sections="listadoDocumentosCtaPubPorAnio" :urlServe="urlServe"/>
            </div>
            <!-- <code>
            {{informacionCOPporAnio}}

            </code> -->
            <div v-if="informacionCOPporAnio && informacionCOPporAnio.length > 0" class="col-md-12">
                <h5>Información Consolidada por Organismo Público</h5>
                <card-collapse-docs :sections="informacionCOPporAnio" :urlServe="urlServe"/>
            </div>
        </div>

        <div class="text-aviso my-5">
            <h5>Comentarios y Sugerencias al tel: (01 961 ) 69- 1 40 43 Extensión: 65059 o al Correo Electrónico: <span class="resaltado-vino"><a :href="'mailto:mcnucamendi@'+urlSubdominio">mcnucamendi@{{ urlSubdominio }}</a></span></h5>
        </div>
        <span v-html="fecha_actualizacion"></span>
    </div>
</template>
<script>
import mapFun from '@/common/map-fn-types.js';
import CuentasPublicas from "@/services/rendicionDeCuentas/cuentasPublicas/cuentasPublicas.js"
const _serviciosCuentasPublicas = new CuentasPublicas();
import selectEjercicio from "../../../components/selectEjercicio.vue";
import botonAtras from '../../button-atras.vue';
import cardCollapseDocsNodos from '@/components/cardCollapseDocsNodos.vue';
import cardCollapseDocs from '@/components/cardCollapseDocs.vue';
import DateFormat from "@/mixins/dateFormatMixin.js";


export default {
    mixins: [DateFormat],
    components: { selectEjercicio, botonAtras, cardCollapseDocsNodos, cardCollapseDocs},
    created(){
        window.scrollTo(0, 0);
        this.getInfoPrincipalCtasPub();
    },
    data(){
        return{
            dataInfoPrincipal: [],
            textoPrincipal: "",
            listadoAnios: [],
            anioSeleccionado: null,

            dataCuentaPubPorAnio: [],
            txtdescripcionCuentaPublica: "",
            listadoDocumentosCtaPubPorAnio: [],
            informacionCOPporAnio: [],
            fecha_actualizacion: '',


        }
    },
    methods:{
        async getInfoPrincipalCtasPub(){
            try {
                const response = await _serviciosCuentasPublicas.getPrincipalCuentasPublicas(mapFun.cuentasPublicasInfoPrincipal);
                this.dataInfoPrincipal = response.data;
                this.fecha_actualizacion = this.DateFormatText(this.dataInfoPrincipal[this.dataInfoPrincipal.length-1].fecha_actualizacion);
            } catch (error) {
                console.log('error', error.message);
            }
        },
        async getTextoPrincipal() {
            try {
                let data_info = this.dataInfoPrincipal.filter(item => item.id === 0);
                this.textoPrincipal = data_info[0].descripcion;

            } catch (error) {
                console.log('error', error.message);
            }
        },
        async getListadoAnios(){
            try {
                this.listadoAnios = this.dataInfoPrincipal.filter(item => item.id != 0);
                this.listadoAnios = this.listadoAnios.reverse();
                this.listadoAnios = this.listadoAnios.map(function (mapeoSelect) {
                    return {
                        id: mapeoSelect.id,
                        value: mapeoSelect.descripcion,
                        text: mapeoSelect.titulo,
                        img: mapeoSelect.recurso,
                    };
                });
            } catch (error) {
                console.log('error', error.message);
            }
        },
        async getAllInfoAnioCuentaPub(){
            try {
                let anio_selec = this.anioSeleccionado.value;
                let ruta = mapFun.cuentasPublicasInfoContenido;
                // console.log("ruta", ruta);
                let ruta_completa = ruta+anio_selec+".json";
                // console.log("rutaaaaa", ruta_completa);
                const response = await _serviciosCuentasPublicas.getAllInfoAnioCuentaPub(ruta_completa);
                this.dataCuentaPubPorAnio = response.data;
            } catch (error) {
                console.log('error', error.message);
            }
        },
        async getDescripcionCtaPubPorAnio() {
            try {
                let data_infoDoc = this.dataCuentaPubPorAnio[0].contenido_anio;
                let data_txt = data_infoDoc.filter(item => item.id === 0);
                this.txtdescripcionCuentaPublica = data_txt[0].descripcion;

            } catch (error) {
                console.log('error', error.message);
            }
        },
        async getListDocsCtaPubPorAnio() {
            try {
                let data_infoDoc = this.dataCuentaPubPorAnio;
                let data_txt = data_infoDoc[0].contenido_anio.filter(item => item.id != 0);
                this.listadoDocumentosCtaPubPorAnio = data_txt;
                this.fecha_actualizacion = this.DateFormatText(this.listadoDocumentosCtaPubPorAnio[this.listadoDocumentosCtaPubPorAnio.length-1].fecha_actualizacion)
            } catch (error) {
                console.log('error', error.message);
            }
        },
        async getInfoCOP(){
            try {
                let anio_selec = this.anioSeleccionado.value;
                let ruta = mapFun.cuentasPublicasInfoCOP;
                let ruta_completa = ruta+anio_selec+"-OP.json";
                const response = await _serviciosCuentasPublicas.getInfoCOP(ruta_completa);
                if(response){
                    this.informacionCOPporAnio = response.data;
                } else{this.informacionCOPporAnio = []; }
            } catch (error) {
                console.log('error', error.message);
            }
        },
    },
    watch:{
        dataInfoPrincipal(){
            if(this.dataInfoPrincipal){
                this.getTextoPrincipal();
                this.getListadoAnios();
            }
        },
        anioSeleccionado(){
            if(this.anioSeleccionado){
                this.getAllInfoAnioCuentaPub();
                this.getInfoCOP();
            }
        },
        dataCuentaPubPorAnio(){
            if(this.dataCuentaPubPorAnio){
                this.getDescripcionCtaPubPorAnio();
                this.getListDocsCtaPubPorAnio();
            }
        }
    }
}
</script>
<style scoped>
a{color: #212529;}
a:hover{color: #212529;}
.resaltado-vino a{
    color: #560F2C !important;
    font-weight: 500 !important;
}
.sub {
  list-style: circle;
  margin-left: 2rem;
}
@media only screen and (max-device-width : 900px){
    .contenedor_img_cp{display: flex; justify-content: center; margin-bottom: 1rem;}
}
</style>
